import React from 'react'
import { Link } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { isDateAfter, isDateBefore } from '../../helper/function'
import CommonDateTimePicker from '../../component/commonDateTimePicker'

const CouponsFilter = ({ showFilter, setShowFilter, setFilterData, handlePagination }) => {
  const collapse = true
  const { control, trigger, reset, handleSubmit, watch } = useForm({})

  const handleFilterclear = () => {
    reset({
      name: '',
      coupon_code: '',
      discount: '',
      amount: '',
      created_start: '',
      created_end: ''
    })
    setFilterData({})
    handlePagination(1, 6)
    setShowFilter(!showFilter)
  }

  const onSubmit = (data) => {
    setFilterData({
      amount: data?.amount ? data?.amount : 0,
      coupon_code: data?.coupon_code,
      name: data?.name,
      created_start: data?.created_start ? data?.created_start : undefined,
      created_end: data?.created_end ? data?.created_end : undefined,
      discount: data?.discount
    })
    handlePagination(1, 6)
    setShowFilter(!showFilter)
  }

  return (
    <div className={`toggle-sidebar ${showFilter ? 'open-filter' : ''}`}>
      <div className="sidebar-layout-filter">
        <div className="sidebar-header">
          <h5>Filter</h5>
          <Link
            to="#"
            className="sidebar-closes"
            onClick={() => {
              setShowFilter(!showFilter)
            }}
          >
            <i className="fa-regular fa-circle-xmark" />
          </Link>
        </div>

        <div className="sidebar-body">
          <div className="title">Coupons</div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div
              id="collapseOne"
              className={collapse ? 'collapse show' : 'collapse'}
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample1"
            >
              <div className="card-body-chat">
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>Coupon Name</label>
                      <Controller
                        name="name"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control bg-transparent dark_border"
                              autoComplete="off"
                              value={value}
                              type="text"
                              placeholder="Search Coupon Name"
                              onChange={(val) => {
                                onChange(val)
                                trigger('name')
                              }}
                            />
                          </>
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>Coupon Code</label>
                      <Controller
                        name="coupon_code"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control bg-transparent dark_border"
                              autoComplete="off"
                              value={value}
                              type="text"
                              placeholder="Search Coupon Code"
                              onChange={(val) => {
                                onChange(val)
                                trigger('name')
                              }}
                            />
                          </>
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>Discount</label>
                      <Controller
                        name="discount"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control bg-transparent dark_border"
                              autoComplete="off"
                              value={value}
                              type="number"
                              placeholder="Search Discount"
                              onChange={(val) => {
                                onChange(val)
                                trigger('name')
                              }}
                            />
                          </>
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>Amount</label>
                      <Controller
                        name="amount"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control bg-transparent dark_border"
                              autoComplete="off"
                              value={value}
                              type="number"
                              placeholder="Search Amount"
                              onChange={(val) => {
                                onChange(val)
                                trigger('name')
                              }}
                            />
                          </>
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <label style={{ color: 'black' }}>Active Coupon Valid Period </label>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>From:</label>
                          <div className='date_picker_main_div'>
                            <CommonDateTimePicker
                              name="created_start"
                              control={control}
                              className="form-control bg-transparent dark_border"
                              placeholder="DD/MM/YYYY"
                              disablePast={false}
                              onDateChange={() => {
                                trigger('created_start')
                              }}
                              shouldDisableDate={(date) => isDateAfter(date, watch('created_end'))}
                              type="DatePicker"
                              format="DD/MM/YYYY"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>To:</label>
                          <div className='date_picker_main_div'>
                            <CommonDateTimePicker
                              name="created_end"
                              control={control}
                              className="form-control bg-transparent dark_border"
                              placeholder="DD/MM/YYYY"
                              disablePast={false}
                              onDateChange={() => {
                                trigger('created_end')
                              }}
                              shouldDisableDate={(date) => isDateBefore(date, watch('created_start'))}
                              type="DatePicker"
                              format="DD/MM/YYYY"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Filter Button */}
            <div className="filter-buttons">
              <button type="submit" className="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary">
                Apply
              </button>
              <button
                type="button"
                onClick={handleFilterclear}
                className="d-inline-flex align-items-center justify-content-center btn w-100 btn-secondary"
              >
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
export default CouponsFilter
